import { extensions } from '../../extensions/Extensions.mjs';
import { detectBasis } from './detectBasis.mjs';
import { loadBasis } from './loadBasis.mjs';

"use strict";
extensions.add(loadBasis, detectBasis);
//# sourceMappingURL=init.mjs.map
